import { Button, ButtonProps } from '@mui/material';

type Props = ButtonProps;

const SmallButton = ({ children, ...props }: Props) => (
  <Button
    {...props}
    size="small"
    sx={{
      height: 'unset',
      fontSize: 'unset',
      paddingTop: 0,
      paddingBottom: 0,
    }}
  >
    {children}
  </Button>
);

export default SmallButton;
